export default __webpack_public_path__ + "static/media/stripe.c0caffd5.svg";